import { Component, Input, OnInit, input, output } from '@angular/core';
import { ButtonModule } from 'primeng/button';


@Component({
    selector: 'pcp-wizardstep',
    templateUrl: './pcpwizardstep.component.html',
    styleUrls: ['./pcpwizardstep.component.scss'],
    standalone: true,
    imports: [ButtonModule]
})
export class PCPWizardStepComponent implements OnInit {
    stepNumber: number = 0;
    activeStep: number = 0;
    // TODO: Skipped for migration because:
    //  Your application code writes to the input. This prevents migration.
    @Input() hidden: boolean = false;
    readonly title = input<string>("");
    readonly colClass = input<string>("col-3");
    readonly showBackButton = input<boolean>(true);
    readonly showNextButton = input<boolean>(true);
    readonly backButtonLabel = input<string>("Back");
    readonly nextButtonLabel = input<string>("Next");
    readonly nextButtonEnabled = input<boolean>(false);
    readonly nextButtonClass = input<string>("");

    readonly onBack = output<any>();
    readonly onNext = output<any>();

    constructor() {

    }

    ngOnInit(): void {
        
    }

    back(): void {
        // TODO: The 'emit' function requires a mandatory any argument
    this.onBack.emit(null);
    }

    next(): void {
        // TODO: The 'emit' function requires a mandatory any argument
    this.onNext.emit(null);
    }
}

